/**
 * Temporary mapping of tactical meal deal ids to their strategic equivalents
 * for use in Meal Deal route redirects following the go-live of the Strategic
 * Meal Deal feature.
 *
 * TODO: https://www.jlpit.com/jira/browse/WPIP-53717
 */
export const tacticalIdToStrategicIdRedirectMap: Record<string, string> = {
  '121': '88089',
  '129': '90550',
  '135': '90874',
  '144': '87428',
  '159': '90946',
  '162': '90969',
  '175': '90155',
  '181': '90758',
  '191': '89979',
  '197': '89977',
  '201': '90350',
};

type PreservedTacticalId = '109' | '114' | '150' | '185';

type NonEmptyArray<T> = [T, ...T[]];

interface StrategicMealDeal {
  id: string;
  startDate: string;
  endDate: string;
}

/**
 * Temporary mapping of tactical meal deal ids to all possible strategic
 * equivalents for "preserved" meal deals as agreed with the SEO Team.
 *
 * When briefed by the Online Merchandising Team per the
 * [Meal Deal Process Document](https://docs.google.com/document/d/1-7sk6UkpivFz4rHcT3zC-rxcdxSbVIe8CppFNa3iq_I)
 * update the map below for all active and upcoming PIC offers that are
 * configured against the 4 preserved tactical meal deal IDs we are supporting.
 *
 * TODO: Remove following phase 2 strategic solution where the BE supports
 * "persistent" meal deal ids that can abstract over multiple PIC offer IDs for
 * a long running or recurring meal deal offer.
 */
export const tacticalIdToStrategicFetcherMap: Record<string, NonEmptyArray<StrategicMealDeal>> = {
  '109': [
    {
      id: '94894',
      startDate: '2026-02-09',
      endDate: '2026-07-07',
    },
    {
      id: '96025',
      startDate: '2026-07-08',
      endDate: '2026-10-27',
    },
    {
      id: '96783',
      startDate: '2026-10-28',
      endDate: '2026-12-29',
    },
  ],
  '114': [
    {
      id: '92979',
      startDate: '2025-04-09',
      endDate: '2025-09-30',
    },
    {
      id: '94173',
      startDate: '2025-10-01',
      endDate: '2026-03-17',
    },
    {
      id: '95196',
      startDate: '2026-03-18',
      endDate: '2026-09-29',
    },
    {
      id: '96458',
      startDate: '2026-10-01',
      endDate: '2026-03-30',
    },
  ],
  '150': [
    {
      id: '87566',
      startDate: '2024-02-07',
      endDate: '2024-02-14',
    },
    {
      id: '92513',
      // Start data is actually '2025-02-07' but will will start pulling
      // through AEM content early as this isn't a "continuous" meal deal like
      // the other deals.
      startDate: '2024-02-15',
      endDate: '2025-02-14',
    },
    {
      id: '94866',
      startDate: '2026-01-01',
      endDate: '2026-02-15',
    },
  ],
  '185': [
    {
      id: '96187',
      startDate: '2026-10-06',
      endDate: '2026-10-27',
    },
    {
      id: '96782',
      startDate: '2026-10-28',
      endDate: '2027-04-20',
    },
  ],
};

/**
 * Temporary mapping of strategic meal deal ids back to their tactical
 * equivalents for "preserved" meal deals as agreed with the SEO Team.
 *
 * TODO: Remove following phase 2 strategic solution where the BE supports
 * "persistent" meal deal ids that can abstract over multiple PIC offer IDs for
 * a long running or recurring meal deal offer.
 */
export const strategicIdToPreservedTacticalIdRedTextMap: Record<string, PreservedTacticalId> =
  Object.entries(tacticalIdToStrategicFetcherMap).reduce(
    (currentMap, [tacticalId, strategicMealDeal]) => {
      strategicMealDeal.forEach(({ id }) => {
        currentMap[id] = tacticalId as PreservedTacticalId;
      });

      return currentMap;
    },
    {} as Record<string, PreservedTacticalId>,
  );
